module.exports = __webpack_public_path__ + "img/Y.d0d79637.jpg";